import { render, staticRenderFns } from "./ServerData.vue?vue&type=template&id=3d84b730&lang=pug&"
import script from "./ServerData.vue?vue&type=script&lang=js&"
export * from "./ServerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports